import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileInfo } from '../kyc-upload.types';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
})
export class DocumentPreviewComponent {
  @Input() fileInfo!: FileInfo;
  @Input() label: string = 'Document';
  @Input() canRemove: boolean = true;
  @Input() canRotate: boolean = false;
  @Input() canZoom: boolean = false;

  @Output() remove = new EventEmitter<void>();
  @Output() replace = new EventEmitter<void>();

  rotation: number = 0;
  zoom: number = 1;

  constructor() {}

  get isPdf(): boolean {
    return this.fileInfo.type === 'pdf';
  }

  get isImage(): boolean {
    return this.fileInfo.type === 'image';
  }

  get transformStyle(): string {
    return `rotate(${this.rotation}deg) scale(${this.zoom})`;
  }

  rotateImage() {
    this.rotation = (this.rotation + 90) % 360;
  }

  zoomIn() {
    this.zoom = Math.min(this.zoom + 0.25, 3);
  }

  zoomOut() {
    this.zoom = Math.max(this.zoom - 0.25, 0.5);
  }

  resetZoom() {
    this.zoom = 1;
    this.rotation = 0;
  }

  onRemove() {
    this.remove.emit();
  }

  onReplace() {
    this.replace.emit();
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }
}
